import { useCallback } from "react";

import useCart from "./useCart.js";
import { get } from "lib/http";

export default function useProductValidator() {
  const [cart, dispatch] = useCart();
  const validate = useCallback(() => {
    if (!cart) {
      return true;
    }
    cart.selection.map(({ product }) =>
      get(`/ecom/productsbypk/${product.id}/`).then((res) => {
        if (!res?.id && !product.isSold) {
          dispatch({ type: "add", product: { ...product, isSold: true } });
        }
      })
    );
  }, [cart, dispatch]);

  const cartValidity = cart?.selection.every((i) => !i.product.isSold) || false;

  return [cartValidity, validate];
}
